/* istanbul ignore file */
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { UserGrantsProvider } from "features/user/contexts/userGrantsContext";
import { OIDCAuthProvider } from "features/auth/providers/OIDCAuthProvider";
import { AppRoutes } from "../Routes/AppRoutes";
import { theme } from "../../theme";
import "dayjs/locale/de-ch";
import { FileTsProvider } from "features/user/contexts/FileTsContext";

export const App = () => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de-ch">
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <OIDCAuthProvider>
        <UserGrantsProvider>
          <FileTsProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </FileTsProvider>
        </UserGrantsProvider>
      </OIDCAuthProvider>
    </ThemeProvider>
  </LocalizationProvider>
);

export default App;
